<template>
  <div>
    <div class="video-player" v-if="selectedVideo.length > 0">
      <box-icon
        class="box-icon video-player__close"
        name="x"
        title="Close Preview"
        @click="closePreview"
      />
      <iframe
        class="video-player__frame"
        :src="selectedVideo"
        title="YouTube video player"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture;fullscreen"
      ></iframe>
      <hr class="video-player__bottom" />
    </div>
    <div v-if="youtubeSearch.length > 0" class="youtube_search mb-3">
      <div
        class="youtube_search__list"
        :key="item.id"
        v-for="item in youtubeSearch"
      >
        <div
          @click="setSelectedVideo(item.embed)"
          @mouseover="setMouseHoverIframe(item.id)"
          @mouseleave="setMouseOutIframe"
          class="youtube_search__thumbnail"
        >
          <img
            v-if="!thumbnailMouse.includes(item.id)"
            :src="item.thumbnail"
            alt=""
          />
          <iframe
            v-if="thumbnailMouse.includes(item.id)"
            class="iframe-widget"
            :src="youtubeEmbed(item.embed)"
            title="YouTube video player"
            frameborder="0"
            allow="autoplay; mute; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
            autoplay
            mute
          ></iframe>
        </div>
        <div class="youtube_search__detail">
          <div class="heading">
            <div>{{ item.title.slice(0, 20) }}...</div>
          </div>
          <div class="d-flex meta">
            <p>{{ item.uploaded_by }}</p>
            <p>{{ item.runtime }}</p>
          </div>
            <div class="noteItem-preference__btn">
              <box-icon
                @click="addYoutubeToNote(item)"
                name="cloud-snow"
                title="Add to Graph"
                class="noteItem-preference__icon box-icon box-icon--effect"
              ></box-icon>
            </div>
        </div>
      </div>
      <div class="d-grid gap-2">
        <button
          @click="nextPage"
          type="button"
          class="btn btn-outline-secondary"
        >
          Next ->
        </button>
      </div>
    </div>
    <div v-else class="px-4 py-4">
      You haven't selected a node yet.
    </div>
  </div>
</template>

<script>
import exploreOps from '@/utils/exploreOps';
import graphReactor from '@/graphReactor';

export default {
  data() {
    return {
      searchWord: '',
      selectedVideo: '',
      thumbnailMouse: [],
    };
  },

  computed: {
    youtubeSearch() {
      return this.$store.getters.getYoutubeData;
    },
  },

  mounted() {},

  created() {
    this.$highway.singleDispatcher('youtubeSearchByKeyword');
  },

  methods: {
    youtubeEmbed(url) {
      if (url) {
        const regex = /^https?:\/\/(?:www\.)?(?:youtube\.com\/(?:embed\/|v\/|watch\?v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})(?:\S+)?$/;
        const match = url.match(regex);
        if (match && match[1].length === 11) {
          return `https://www.youtube.com/embed/${match[1]}?rel=0&autoplay=1&mute=1&controls=0`;
        }
      }
      return '';
      // return `${embed}?autoplay=1&mute=1`;
    },
    SelectedVideoEmbed(url) {
      if (url) {
        const regex = /^https?:\/\/(?:www\.)?(?:youtube\.com\/(?:embed\/|v\/|watch\?v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})(?:\S+)?$/;
        const match = url.match(regex);
        if (match && match[1].length === 11) {
          return `https://www.youtube.com/embed/${match[1]}?rel=0&autoplay=1`;
        }
      }
      return '';
      // return `${embed}?autoplay=1&mute=1`;
    },
    async addYoutubeToNote(item) {
      const val = {
        id: item.id,
        value: {
          noteUrl: item.embed,
          videoLabel: `${item.title.slice(0, 20)}...`,
          type: 'video',
        },
      };
      await exploreOps.addNoteToGraph(val);
      const { word } = this.$store.state.current_selected_entity;
      console.log(word);

      console.log({
        source: item.id,
        target: word,
        label: 'has note',
        style: {
          endArrow: true,
        },
      });
      graphReactor.exploreInstance.addItem('edge', {
        source: item.id,
        target: word,
        label: 'has note',
        style: {
          endArrow: true,
        },
      });
    },

    searchYoutubeByKeyowrd() {
      this.$store.dispatch('youtubeSearchByKeyword', this.searchWord);
    },
    nextPage() {
      this.$store.dispatch('youtubeSearchUsingNextPage');
    },

    pageJump(code) {
      this.$store.dispatch('youtubePageJump', code);
    },
    setMouseHoverIframe(id) {
      this.thumbnailMouse = [id];
    },
    setMouseOutIframe() {
      this.thumbnailMouse = [];
    },
    setSelectedVideo(video) {
      console.log('YOUTUBE', video);
      this.selectedVideo = this.SelectedVideoEmbed(video);
    },
    // clearSetMouse() {
    //   this.thumbnailMouse = [];
    // },
    closePreview() {
      this.selectedVideo = '';
    },
  },
};
</script>

<style lang="scss" scoped>
.youtube_search {
  // width: auto;
  display: flex;
  flex-wrap: wrap;
  background-color: #fff;
  // max-height: 30rem;
  overflow: auto;
  &__list {
    // width: 100%;
    max-width: 220px;
    // width: 100%;
    // height: 120px;
    // display: flex;
    justify-content: space-between;
    margin: 1rem;
    border-radius: 3px;
    background-color: #fff;
    padding: 0.25rem;
    transition: all 0.3s ease-in-out;
    &:hover {
      // box-shadow: 0 0 15px 5px rgba(0, 0, 0, 0.1);
      cursor: pointer;
    }
  }

  &__detail {
    font-size: 0.8rem;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 0.5rem;

    .heading {
      width: auto;
    }
    .meta {
      display: flex;
      justify-content: space-between;
    }
  }

  &__thumbnail {
    overflow: hidden;
    display: flex;
    justify-content: center;
    position: relative;

    img {
      min-width: 100%;
      max-width: 360px;
      min-height: 100%;
      transition: all 0.3s ease-in-out;
      border-radius: 3px;

      // &:hover {
      //   cursor: pointer;
      //   border-radius: 3px;
      //   transform: scale(1.1);
      // }
    }
    .iframe-widget {
      width: 100%;
      height: 100%;
      pointer-events: none;
      // position: absolute;
      // transition: all 0.3s ease-in-out;
      // border-radius: 3px;

      // &:hover {
      //   cursor: pointer;
      // }
    }
  }
}
.video-player {
  max-height: 26rem;
  position: relative;
  margin-top: 1rem;
  width: 100%;
  &__frame {
    width: 100%;
    max-height: 25rem;
    aspect-ratio: 2/1;
  }
  &__empty {
    max-height: 26rem;
    width: 100%;
  }
  &__icon {
    fill: red;
  }
  &__bottom {
    color: #76797b;
  }
  &__close {
    margin-left: auto;
    position: absolute;
    top: -2rem;
    right: 0.1rem;
  }
}
</style>
